export enum AppRoles {
  Default = '',
  AppAdmin = 'AppAdmin',
  Manager = 'Manager',
  Admin = 'Admin',
  User = 'User',
}
